import { defineStore } from 'pinia'
import {
  getProducts,
  getUserPrintTemplates,
  deleteUserPrintTemplate,
  saveUserPrintTemplate
} from '@/features/productOrder/ProductOrderApi'

export const useProductOrderStore = defineStore('productOrder', {
  state: () => ({
    products: [
      //zelf samenstellen
      {
        image: 'default/sliders.svg',
        title: 'Zelf samenstellen',
        menus: [
          {
            title: 'Printopties',
            description: '',
            optionGroups: [
              {
                name: 'formaat',
                productionCategory: '',
                default: 'ALS_BESTAND',
                analyseValue: true,
                options: [
                  {
                    priceKey: 'formaat',
                    name: 'A0',
                    title: 'A0',
                    disabledWhen: []
                  },
                  {
                    priceKey: 'formaat',
                    name: 'A1',
                    title: 'A1',
                    disabledWhen: []
                  },
                  {
                    priceKey: 'formaat',
                    name: 'A2',
                    title: 'A2',
                    disabledWhen: []
                  },
                  {
                    priceKey: 'formaat',
                    name: 'A3',
                    title: 'A3',
                    disabledWhen: []
                  },
                  {
                    priceKey: 'formaat',
                    name: 'A4',
                    title: 'A4',
                    disabledWhen: []
                  },
                  {
                    priceKey: 'formaat',
                    name: 'A5',
                    title: 'A5',
                    disabledWhen: []
                  },
                  {
                    priceKey: 'formaat',
                    name: 'A6',
                    title: 'A6',
                    disabledWhen: []
                  },
                  {
                    priceKey: 'formaat',
                    name: 'ALS_BESTAND',
                    title: 'Als bestand',
                    disabledWhen: []
                  }
                ]
              },
              {
                name: 'printkleur',
                productionCategory: 'Printopties',
                default: 'ZWART_WIT',
                analyseValue: true,
                options: [
                  {
                    name: 'KLEUR',
                    title: 'Kleur',
                    priceKey: 'printkleur',
                    disabledWhen: []
                  },
                  {
                    name: 'ZWART_WIT',
                    title: 'Zwart / wit',
                    priceKey: 'printkleur',
                    disabledWhen: []
                  }
                ]
              },
              {
                name: 'printwijze',
                productionCategory: 'Printopties',
                default: 'Enkelzijdig',
                options: [
                  {
                    priceKey: 'printwijze',
                    name: 'Enkelzijdig',
                    title: 'Enkelzijdig',
                    disabledWhen: []
                  },
                  {
                    priceKey: 'printwijze',
                    name: 'Dubbelzijdig',
                    title: 'Dubbelzijdig',
                    disabledWhen: ['A0', 'A1', 'A2'],
                    disabledReason: 'Niet beschikbaar voor grote formaten'
                  }
                ]
              },
              {
                name: 'papierType',
                productionCategory: 'Printopties',
                default: '_75_GRAMS',
                options: [
                  {
                    name: 'Standaard papier',
                    title: 'Standaard papier',
                    subOptions: [
                      {
                        name: '_75_GRAMS',
                        priceKey: 'papierType',
                        title: '75 Grams papier',
                        hideWhen: ['A6', 'A5', 'A4', 'A3']
                      },
                      {
                        name: '_80_GRAMS',
                        priceKey: 'papierType',
                        title: '80 Grams papier',
                        hideWhen: ['A2', 'A1', 'A0']
                      },
                      {
                        name: '_100_GRAMS',
                        priceKey: 'papierType',
                        title: '100 Grams papier',
                        hideWhen: ['A2', 'A1', 'A0']
                      },
                      {
                        name: '_120_GRAMS',
                        priceKey: 'papierType',
                        title: '120 Grams papier'
                      },
                      {
                        name: '_160_GRAMS',
                        priceKey: 'papierType',
                        title: '160 Grams papier',
                        hideWhen: ['A2', 'A1', 'A0']
                      },
                      {
                        name: '_200_GRAMS',
                        priceKey: 'papierType',
                        title: '200 Grams papier',
                        hideWhen: ['A2', 'A1', 'A0']
                      },
                      {
                        name: '_250_GRAMS',
                        priceKey: 'papierType',
                        title: '250 Grams papier',
                        hideWhen: ['A2', 'A1', 'A0']
                      },
                      {
                        name: '_300_GRAMS',
                        priceKey: 'papierType',
                        title: '300 Grams papier',
                        hideWhen: ['A2', 'A1', 'A0']
                      }
                    ]
                  },
                  {
                    name: 'MC Gloss',
                    title: 'MC Gloss papier',
                    hideWhen: ['A0', 'A1', 'A2'],
                    subOptions: [
                      {
                        name: 'MC_GLOSS_115G',
                        priceKey: 'papierType',
                        title: 'MC Gloss 115g',
                        hideWhen: ['A0', 'A1', 'A2']
                      },
                      {
                        name: 'MC_GLOSS_150G',
                        priceKey: 'papierType',
                        title: 'MC Gloss 150g',
                        hideWhen: ['A0', 'A1', 'A2']
                      },
                      {
                        name: 'MC_GLOSS_200G',
                        priceKey: 'papierType',
                        title: 'MC Gloss 200g',
                        hideWhen: ['A0', 'A1', 'A2']
                      },
                      {
                        name: 'MC_GLOSS_250G',
                        priceKey: 'papierType',
                        title: 'MC Gloss 250g',
                        hideWhen: ['A0', 'A1', 'A2']
                      }
                    ]
                  },
                  {
                    name: 'Off white',
                    title: 'Off white papier',
                    hideWhen: ['A0', 'A1', 'A2'],
                    subOptions: [
                      {
                        name: 'OFF_WHITE_80G',
                        priceKey: 'papierType',
                        title: 'Off-white 80g',
                        hideWhen: ['A0', 'A1', 'A2']
                      },
                      {
                        name: 'OFF_WHITE_100G',
                        priceKey: 'papierType',
                        title: 'Off-white 100g',
                        hideWhen: ['A0', 'A1', 'A2']
                      },
                      {
                        name: 'OFF_WHITE_200G',
                        priceKey: 'papierType',
                        title: 'Off-white 200g',
                        hideWhen: ['A0', 'A1', 'A2']
                      },
                      {
                        name: 'OFF_WHITE_300G',
                        priceKey: 'papierType',
                        title: 'Off-white 300g',
                        hideWhen: ['A0', 'A1', 'A2']
                      }
                    ]
                  },
                  {
                    name: 'Sticker',
                    title: 'Sticker',
                    subOptions: [
                      {
                        name: 'PERMANENTE_STICKER',
                        priceKey: 'papierType',
                        title: 'Permanente sticker',
                        disabledWhen: []
                      },
                      {
                        name: 'VERWIJDERBARE_STICKER',
                        priceKey: 'papierType',
                        title: 'Verwijderbare sticker',
                        disabledWhen: []
                      }
                    ]
                  },
                  {
                    name: 'NEVERTEAR',
                    priceKey: 'papierType',
                    title: 'Nevertear',
                    hideWhen: ['A0', 'A1', 'A2']
                  },
                  {
                    name: 'TYVEK_75G',
                    priceKey: 'papierType',
                    title: 'Tyvek 75g',
                    hideWhen: ['A0', 'A1', 'A2']
                  },
                  {
                    name: 'Meer materialen',
                    title: 'Meer materialen',
                    hideWhen: ['A6', 'A5', 'A4', 'A3'],
                    subOptions: [
                      {
                        name: 'BACKLIT_FILM',
                        priceKey: 'papierType',
                        title: 'Backlit Film',
                        hideWhen: ['A6', 'A5', 'A4', 'A3']
                      },
                      {
                        name: 'BANNER',
                        priceKey: 'papierType',
                        title: 'Banner',
                        hideWhen: ['A6', 'A5', 'A4', 'A3']
                      },
                      {
                        name: 'FLUOR_GEEL_PAPIER',
                        priceKey: 'papierType',
                        title: 'Fluor geel papier',
                        hideWhen: ['A6', 'A5', 'A4', 'A3']
                      },
                      {
                        name: 'POLYESTER_DOEK_195G',
                        priceKey: 'papierType',
                        title: 'Polyester doek 195g',
                        hideWhen: ['A6', 'A5', 'A4', 'A3']
                      },
                      {
                        name: 'TYVEK_75G_kf',
                        priceKey: 'papierType',
                        title: 'Tyvek 75g',
                        hideWhen: ['A6', 'A5', 'A4', 'A3']
                      },
                      {
                        name: 'TYVEK_75G_STANDAARD_75G',
                        priceKey: 'papierType',
                        title: 'Tyvek 75g + standaard 75g',
                        hideWhen: ['A6', 'A5', 'A4', 'A3']
                      },
                      {
                        name: 'WIT_PAPIER_150G_FSC_GLANS',
                        priceKey: 'papierType',
                        title: 'Wit papier 150g FSC Glans',
                        hideWhen: ['A6', 'A5', 'A4', 'A3']
                      },
                      {
                        name: 'WIT_PAPIER_150G_FSC_MAT',
                        priceKey: 'papierType',
                        title: 'Wit papier 150g FSC Mat',
                        hideWhen: ['A6', 'A5', 'A4', 'A3']
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            title: 'Afwerking',
            description: '',
            optionGroups: [
              {
                name: 'afwerking',
                productionCategory: 'Afwerking',
                default: 'A4 vouwen',
                options: [
                  {
                    name: 'NONE',
                    priceKey: 'afwerking',
                    title: 'Geen afwerking',
                    hideWhen: ['A0', 'A1', 'A2']
                  },
                  {
                    name: 'VOUWEN',
                    priceKey: 'afwerking',
                    title: 'Vouwen',
                    hideWhen: ['A0', 'A1', 'A2']
                  },
                  {
                    name: 'Vouw opties',
                    title: 'Vouw opties',
                    hideWhen: ['A3', 'A4', 'A5', 'A6'],
                    subOptions: [
                      {
                        name: 'A4_VOUWEN',
                        priceKey: 'afwerking',
                        title: 'A4 vouwen',
                        hideWhen: ['A3', 'A4', 'A5', 'A6']
                      },
                      {
                        name: '_19CM_VOUWEN',
                        priceKey: 'afwerking',
                        title: '19cm vouwen',
                        hideWhen: ['A3', 'A4', 'A5', 'A6']
                      },
                      {
                        name: '_19CM_VOUWEN_4GATEN',
                        priceKey: 'afwerking',
                        title: '19cm vouwen hechtrand + 4 gaten',
                        hideWhen: ['A3', 'A4', 'A5', 'A6']
                      }
                    ]
                  },
                  {
                    name: 'ROLLEN',
                    priceKey: 'afwerking',
                    title: 'Rollen',
                    hideWhen: ['Ringband']
                  },
                  {
                    name: 'Boren',
                    title: 'Boren',
                    subOptions: [
                      {
                        name: 'BOREN_2_GATEN',
                        priceKey: 'afwerking',
                        title: 'Boren 2 gaten'
                      },
                      {
                        name: 'BOREN_4_GATEN',
                        priceKey: 'afwerking',
                        title: 'Boren 4 gaten'
                      }
                    ]
                  },
                  {
                    name: 'Plastificeren',
                    title: 'Plastificeren',
                    subOptions: [
                      {
                        name: 'PLASTIFICEREN_MAT',
                        priceKey: 'afwerking',
                        title: 'Plastificeren mat'
                      },
                      {
                        name: 'PLASTIFICEREN_GLANS',
                        priceKey: 'afwerking',
                        title: 'Plastificeren glans'
                      }
                    ]
                  }
                ]
              },
              {
                name: 'bindwijze',
                productionCategory: 'Afwerking',
                default: 'NONE',
                options: [
                  {
                    name: 'NONE',
                    priceKey: 'bindwijze',
                    title: 'Niet inbinden'
                  },
                  {
                    name: 'Nieten',
                    title: 'Nieten',
                    hideWhen: ['A0', 'A1', 'A2', 'ROLLEN'],
                    subOptions: [
                      {
                        name: 'NIETEN_1_NIETJE',
                        priceKey: 'bindwijze',
                        title: 'Nieten 1 nietje',
                        hideWhen: ['A0', 'A1', 'A2', 'ROLLEN']
                      },
                      {
                        name: 'NIETEN_2_NIETJES',
                        priceKey: 'bindwijze',
                        title: 'Nieten 2 nietjes',
                        hideWhen: ['A0', 'A1', 'A2', 'ROLLEN']
                      }
                    ]
                  },
                  {
                    name: 'Ringband',
                    title: 'Ringband',
                    hideWhen: ['A0', 'A1', 'A2', 'ROLLEN'],
                    subOptions: [
                      {
                        name: 'WIRE_O',
                        priceKey: 'bindwijze',
                        title: 'Ringband metaal',
                        hideWhen: ['A0', 'A1', 'A2', 'ROLLEN']
                      },
                      {
                        name: 'WIRE_O_TRANSPARANT_VOOR_KARTON_ACHTER',
                        priceKey: 'bindwijze',
                        title:
                          'Ringband metaal, transparant voor, karton achter',
                        hideWhen: ['A0', 'A1', 'A2', 'ROLLEN']
                      },
                      {
                        name: 'WIRE_O_TRANSPARANT_VOOR_EN_ACHTER',
                        priceKey: 'bindwijze',
                        title: 'Ringband metaal, transparant voor en achter',
                        hideWhen: ['A0', 'A1', 'A2', 'ROLLEN']
                      },
                      {
                        name: 'PLASTIC_BINDRUG',
                        priceKey: 'bindwijze',
                        title: 'Ringband plastic',
                        hideWhen: ['A0', 'A1', 'A2', 'ROLLEN']
                      },
                      {
                        name: 'PLASTIC_BINDRUG_TRANSPARANT_VOOR_KARTON_ACHTER',
                        priceKey: 'bindwijze',
                        title:
                          'Ringband plastic, transparant voor, karton achter',
                        hideWhen: ['A0', 'A1', 'A2', 'ROLLEN']
                      },
                      {
                        name: 'PLASTIC_BINDRUG_TRANSPARANT_VOOR_EN_ACHTER',
                        priceKey: 'bindwijze',
                        title: 'Ringband plastic, transparant voor en achter',
                        hideWhen: ['A0', 'A1', 'A2', 'ROLLEN']
                      }
                    ]
                  },
                  {
                    name: 'BUIS_BINDER',
                    priceKey: 'bindwijze',
                    title: 'Buis binder',
                    hideWhen: ['ROLLEN']
                  }
                ]
              }
            ]
          },
          {
            title: 'Opmerking',
            description:
              'Plaats hier eventuele bijzonderheden met betrekking tot de geselecteerde bestanden.',
            optionGroups: [
              {
                name: 'opmerking',
                productionCategory: 'Opmerking'
              }
            ]
          }
        ]
      },
      //bouwtekening
      {
        image: 'default/bouwtekening.svg',
        title: 'Bouwtekening',
        menus: [
          {
            title: 'Printopties',
            description: '',
            optionGroups: [
              {
                name: 'formaat',
                productionCategory: 'Printopties',
                default: '_BESTAND',
                options: [
                  {
                    priceKey: 'formaat',
                    name: 'A0',
                    title: 'A0',
                    disabledWhen: []
                  },
                  {
                    priceKey: 'formaat',
                    name: 'A1',
                    title: 'A1',
                    disabledWhen: []
                  },
                  {
                    priceKey: 'formaat',
                    name: 'A2',
                    title: 'A2',
                    disabledWhen: []
                  },
                  {
                    priceKey: 'formaat',
                    name: 'A3',
                    title: 'A3',
                    disabledWhen: []
                  },
                  {
                    priceKey: 'formaat',
                    name: '_BESTAND',
                    title: 'Als bestand',
                    disabledWhen: []
                  }
                ]
              },
              {
                name: 'printkleur',
                productionCategory: 'Printopties',
                default: 'KLEUR',
                options: [
                  {
                    name: 'KLEUR',
                    title: 'Kleur',
                    disabledWhen: [],
                    priceKey: 'printkleur'
                  },
                  {
                    name: 'ZWART_WIT',
                    title: 'Zwart / wit',
                    priceKey: 'printkleur',
                    disabledWhen: []
                  }
                ]
              },
              {
                name: 'papierType',
                productionCategory: 'Printopties',
                default: '_75_GRAMS',
                options: [
                  {
                    name: '_75_GRAMS',
                    title: '75 grams',
                    disabledWhen: [],
                    priceKey: 'papierType'
                  },
                  {
                    name: '_120_GRAMS',
                    title: '120 grams',
                    priceKey: 'papierType'
                  },
                  {
                    name: 'TYVEK',
                    title: 'Tyvek',
                    priceKey: 'papierType'
                  },
                  {
                    name: '_75_GRAMS_PLUS_TYVEK',
                    title: '75 grams + Tyvek',
                    disabledWhen: [],
                    priceKey: 'papierType'
                  },
                  {
                    name: '_75_GRAMS_PLUS_GEEL',
                    title: '75 grams + Geel papier',
                    disabledWhen: [],
                    priceKey: 'papierType'
                  }
                ]
              }
            ]
          },
          {
            title: 'Afwerking',
            description: '',
            optionGroups: [
              {
                name: 'afwerking',
                productionCategory: 'Afwerking',
                default: 'A4_VOUWEN',
                options: [
                  {
                    name: 'A4_VOUWEN',
                    title: 'A4 vouwen',
                    disabledWhen: [],
                    priceKey: 'afwerking'
                  },
                  {
                    name: 'ROLLEN',
                    title: 'Rollen',
                    disabledWhen: [],
                    priceKey: 'afwerking'
                  }
                ]
              },
              {
                name: 'boren',
                productionCategory: 'Afwerking',
                default: 'NONE',
                options: [
                  {
                    name: 'NONE',
                    title: 'Geen boorgaten',
                    disabledWhen: [],
                    priceKey: 'afwerking'
                  },
                  {
                    name: '2 GATEN',
                    title: '2 gaten boren',
                    priceKey: 'afwerking'
                  },
                  {
                    name: '4 gaten',
                    title: '4 gaten boren',
                    priceKey: 'afwerking'
                  }
                ]
              },
              {
                name: 'plastificeren',
                productionCategory: 'Afwerking',
                default: 'NONE',
                options: [
                  {
                    name: 'NONE',
                    title: 'Niet plastificeren',
                    disabledWhen: [],
                    priceKey: 'plastificeren'
                  },
                  {
                    name: 'PLASTIFICEREN_GLANS',
                    title: 'Plastificeren glans',
                    disabledWhen: ['A4_VOUWEN'],
                    priceKey: 'plastificeren'
                  },
                  {
                    name: 'PLASTIFICEREN_MAT',
                    title: 'Plastificeren mat',
                    disabledWhen: ['A4_VOUWEN'],
                    priceKey: 'plastificeren'
                  }
                ]
              }
            ]
          },
          {
            title: 'Bedrukking',
            hidden: true,
            optionGroups: [
              {
                name: 'printwijze',
                productionCategory: 'Bedrukking',
                default: 'Enkelzijdig',
                options: [
                  {
                    priceKey: 'printwijze',
                    name: 'Enkelzijdig',
                    title: 'Enkelzijdig',
                    disabledWhen: []
                  }
                ]
              }
            ]
          },
          {
            title: 'Opmerking',
            description:
              'Plaats hier eventuele bijzonderheden met betrekking tot de geselecteerde bestanden.',
            optionGroups: [
              {
                name: 'opmerking',
                productionCategory: 'Opmerking'
              }
            ]
          }
        ]
      },
      //boekje
      {
        title: 'Boekje',
        image: 'default/boekje.svg',
        menus: [
          {
            title: 'Printopties',
            description: '',
            optionGroups: [
              {
                name: 'formaat',
                productionCategory: 'Printopties',
                default: 'A4',
                options: [
                  {
                    name: 'A3',
                    title: 'A3',
                    priceKey: 'formaat'
                  },
                  {
                    name: 'A4',
                    title: 'A4',
                    priceKey: 'formaat'
                  },
                  {
                    name: 'A5',
                    title: 'A5',
                    priceKey: 'formaat'
                  }
                ]
              },
              {
                name: 'printkleur',
                productionCategory: 'Printopties',
                default: 'KLEUR',
                analyseValue: true,
                options: [
                  {
                    name: 'KLEUR',
                    title: 'Kleur',
                    priceKey: 'printkleur',
                    disabledWhen: []
                  },
                  {
                    name: 'ZWART_WIT',
                    title: 'Zwart / wit',
                    priceKey: 'printkleur',
                    disabledWhen: []
                  }
                ]
              },
              {
                name: 'printwijze',
                productionCategory: 'Printopties',
                default: 'Dubbelzijdig',
                options: [
                  {
                    priceKey: 'printwijze',
                    name: 'Enkelzijdig',
                    title: 'Enkelzijdig',
                    disabledWhen: []
                  },
                  {
                    priceKey: 'printwijze',
                    name: 'Dubbelzijdig',
                    title: 'Dubbelzijdig',
                    disabledWhen: []
                  }
                ]
              },
              {
                name: 'papierType',
                productionCategory: 'Printopties',
                default: '_100_GRAMS',
                options: [
                  {
                    name: '_80_GRAMS',
                    title: '80 grams',
                    disabledWhen: [],
                    priceKey: 'papierType'
                  },
                  {
                    name: '_100_GRAMS',
                    title: '100 grams',
                    disabledWhen: [],
                    priceKey: 'papierType'
                  },
                  {
                    name: '_120_GRAMS',
                    title: '120 grams',
                    disabledWhen: [],
                    priceKey: 'papierType'
                  }
                ]
              }
            ]
          },
          {
            title: 'Voorkant',
            description: '',
            hideWhen: ['GARENLOOS'],
            optionGroups: [
              {
                name: 'toggleOptions',
                default: 'disabled',
                options: [
                  {
                    name: 'enabled',
                    title: 'Met voorblad',
                    priceType: '',
                    disabledWhen: [],
                    priceKey: ''
                  },
                  {
                    name: 'disabled',
                    title: 'Zonder voorblad',
                    priceType: '',
                    disabledWhen: [],
                    priceKey: ''
                  }
                ],
                productionCategory: 'Voorkant'
              },
              {
                name: 'printwijze',
                default: 'Dubbelzijdig',
                options: [
                  {
                    name: 'Enkelzijdig',
                    title: 'Enkelzijdig'
                  },
                  {
                    name: 'Dubbelzijdig',
                    title: 'Dubbelzijdig'
                  }
                ],
                productionCategory: 'Voorkant'
              },
              {
                name: 'printkleur',
                default: 'KLEUR',
                options: [
                  {
                    name: 'KLEUR',
                    title: 'Kleur'
                  },
                  {
                    name: 'ZWART_WIT',
                    title: 'Zwart / wit'
                  }
                ],
                productionCategory: 'Voorkant'
              },
              {
                name: 'papier',
                priceObjectKey: 'voorzijde',
                productionCategory: 'Voorkant',
                default: 'BEDRUKT_STEVIG',
                options: [
                  {
                    name: 'BEDRUKT_STANDAARD',
                    title: 'Standaard (100 grams)',
                    disabledWhen: [],
                    priceKey: 'afwerking'
                  },
                  {
                    name: 'BEDRUKT_STEVIG',
                    title: 'Extra stevig (200 grams)',
                    disabledWhen: [],
                    priceKey: 'afwerking'
                  }
                ]
              },
              {
                name: 'transparant',
                productionCategory: 'Voorkant',
                default: 'TRANSPARANT_PLASTIC',
                options: [
                  {
                    name: 'TRANSPARANT_PLASTIC',
                    title: 'Transparante voorzijde',
                    disabledWhen: [],
                    priceKey: 'afwerking'
                  },
                  {
                    name: 'NONE',
                    title: 'Geen transparante voorzijde',
                    disabledWhen: [],
                    priceKey: 'afwerking'
                  }
                ]
              }
            ]
          },
          {
            title: 'Achterkant',
            description: '',
            hideWhen: ['GARENLOOS'],
            optionGroups: [
              {
                name: 'toggleOptions',
                default: 'disabled',
                options: [
                  {
                    name: 'enabled',
                    title: 'Met achterblad',
                    priceType: '',
                    disabledWhen: [],
                    priceKey: ''
                  },
                  {
                    name: 'disabled',
                    title: 'Zonder achterblad',
                    priceType: '',
                    disabledWhen: [],
                    priceKey: ''
                  }
                ],
                productionCategory: 'Achterkant'
              },
              {
                name: 'printwijze',
                default: 'Dubbelzijdig',
                options: [
                  {
                    name: 'Enkelzijdig',
                    title: 'Enkelzijdig'
                  },
                  {
                    name: 'Dubbelzijdig',
                    title: 'Dubbelzijdig'
                  }
                ],
                productionCategory: 'Achterkant'
              },
              {
                name: 'printkleur',
                default: 'KLEUR',
                options: [
                  {
                    name: 'KLEUR',
                    title: 'Kleur'
                  },
                  {
                    name: 'ZWART_WIT',
                    title: 'Zwart / wit'
                  }
                ],
                productionCategory: 'Achterkant'
              },
              {
                name: 'afwerking',
                priceObjectKey: 'achterzijde',
                productionCategory: 'Achterkant',
                default: 'BEDRUKT_STEVIG',
                options: [
                  {
                    name: 'BEDRUKT_STANDAARD',
                    title: 'Bedrukt, standaard (100 grams)',
                    disabledWhen: [],
                    priceKey: 'afwerking'
                  },
                  {
                    name: 'BEDRUKT_STEVIG',
                    title: 'Bedrukt, extra stevig (200 grams)',
                    disabledWhen: [],
                    priceKey: 'afwerking'
                  },
                  {
                    name: 'BLANCO_STEVIG',
                    title: 'Blanco, extra stevig (200 grams)',
                    disabledWhen: [],
                    priceKey: 'afwerking'
                  }
                ]
              },
              {
                name: 'transparant',
                productionCategory: 'Achterkant',
                default: 'TRANSPARANT_PLASTIC',
                options: [
                  {
                    name: 'TRANSPARANT_PLASTIC',
                    title: 'Transparante achterzijde',
                    disabledWhen: [],
                    priceKey: 'afwerking'
                  },
                  {
                    name: 'NONE',
                    title: 'Geen transparante achterzijde',
                    disabledWhen: [],
                    priceKey: 'afwerking'
                  }
                ]
              }
            ]
          },
          {
            title: 'Afwerking',
            description: '',
            optionGroups: [
              {
                name: 'bindwijze',
                productionCategory: 'Afwerking',
                default: 'WIRE_O',
                options: [
                  {
                    name: 'WIRE_O',
                    priceKey: 'bindwijze',
                    title: 'Ringband metaal'
                  },
                  {
                    name: 'PLASTIC_BINDRUG',
                    priceKey: 'bindwijze',
                    title: 'Ringband plastic'
                  },
                  {
                    name: 'SNELHECHTER',
                    priceKey: 'bindwijze',
                    title: 'Snelhechter'
                  },
                  {
                    name: 'GARENLOOS',
                    priceKey: 'garenloos',
                    title: 'Garenloos binden (lijmen)'
                  }
                ]
              },
              {
                name: 'bindzijde',
                productionCategory: 'Afwerking',
                default: 'LANGE_ZIJDE',
                options: [
                  {
                    name: 'LANGE_ZIJDE',
                    priceKey: 'bindzijde',
                    title: 'Inbinden aan lange zijde'
                  },
                  {
                    name: 'KORTE_ZIJDE',
                    priceKey: 'bindzijde',
                    title: 'Inbinden aan korte zijde'
                  }
                ]
              },
              {
                name: 'schoonsnijden',
                productionCategory: 'Afwerking',
                default: 'SCHOONSNIJDEN',
                options: [
                  {
                    name: 'SCHOONSNIJDEN',
                    title: 'Schoonsnijden',
                    disabledWhen: [],
                    priceKey: 'orderafwerking'
                  },
                  {
                    name: 'NONE',
                    title: 'Niet schoonsnijden',
                    disabledWhen: [],
                    priceKey: 'orderafwerking'
                  }
                ]
              }
            ]
          },
          /* {
            title: 'Omslag',
            description: '',
            hideWhen: ['TRANSPARANT_PLASTIC', 'GEEN_TRANSPARANT_PLASTIC'],
            optionGroups: [
              {
                name: 'afwerking',
                priceObjectKey: 'omslag',
                productionCategory: 'Omslag',
                default: 'STEVIG',
                options: [
                  {
                    name: 'STANDAARD',
                    title: 'Standaard (100 grams)',
                    disabledWhen: [],
                    priceKey: 'afwerking'
                  },
                  {
                    name: 'STEVIG',
                    title: 'Extra stevig (200 grams)',
                    disabledWhen: [],
                    priceKey: 'afwerking'
                  }
                ]
              }
            ]
          }, */

          {
            title: 'Opmerking',
            description:
              'Plaats hier eventuele bijzonderheden met betrekking tot de geselecteerde bestanden.',
            optionGroups: [
              {
                name: 'opmerking',
                productionCategory: 'Opmerking'
              }
            ]
          }
        ]
      },
      //brochure
      {
        title: 'Brochure',
        image: 'default/brochure.svg',
        menus: [
          {
            title: 'Printopties',
            description: '',
            optionGroups: [
              {
                name: 'formaat',
                productionCategory: 'Printopties',
                default: 'A4',
                options: [
                  {
                    name: 'A4',
                    title: 'A4',
                    priceKey: 'formaat'
                  },
                  {
                    name: 'A5',
                    title: 'A5',
                    priceKey: 'formaat'
                  }
                ]
              },
              {
                name: 'printkleur',
                productionCategory: 'Printopties',
                default: 'KLEUR',
                analyseValue: true,
                options: [
                  {
                    name: 'KLEUR',
                    title: 'Kleur',
                    priceKey: 'printkleur',
                    disabledWhen: []
                  },
                  {
                    name: 'ZWART_WIT',
                    title: 'Zwart / wit',
                    priceKey: 'printkleur',
                    disabledWhen: []
                  }
                ]
              },
              {
                name: 'printwijze',
                productionCategory: 'Printopties',
                default: 'Dubbelzijdig',
                options: [
                  {
                    priceKey: 'printwijze',
                    name: 'Enkelzijdig',
                    title: 'Enkelzijdig',
                    disabledWhen: []
                  },
                  {
                    priceKey: 'printwijze',
                    name: 'Dubbelzijdig',
                    title: 'Dubbelzijdig',
                    disabledWhen: []
                  }
                ]
              },
              {
                name: 'papierType',
                productionCategory: 'Printopties',
                default: '_100_GRAMS',
                options: [
                  {
                    name: '_80_GRAMS',
                    title: '80 grams',
                    disabledWhen: [],
                    priceKey: 'papierType'
                  },
                  {
                    name: '_100_GRAMS',
                    title: '100 grams',
                    disabledWhen: [],
                    priceKey: 'papierType'
                  },
                  {
                    name: '_120_GRAMS',
                    title: '120 grams',
                    disabledWhen: [],
                    priceKey: 'papierType'
                  }
                ]
              }
            ]
          },
          {
            title: 'Omslag',
            description: '',
            optionGroups: [
              {
                name: 'omslagBedrukking',
                productionCategory: 'Omslag',
                default: 'BEDRUKT_VOOR_EN_ACHTER',
                options: [
                  {
                    name: 'BEDRUKT_VOOR_EN_ACHTER',
                    title: 'Voor- en achterzijde bedrukt',
                    disabledWhen: [],
                    priceKey: 'afwerking'
                  },
                  {
                    name: 'BEDRUKT_PAGINA_1_EN_2',
                    title: 'Pagina 1 en 2 bedrukt',
                    disabledWhen: [],
                    priceKey: 'afwerking'
                  },
                  {
                    name: 'BEDRUKT_VOORZIJDE',
                    title: 'Alleen voorzijde bedrukt',
                    disabledWhen: [],
                    priceKey: 'afwerking'
                  }
                ]
              },
              {
                name: 'omslagPapier',
                productionCategory: 'Omslag',
                default: '_160_GRAMS',
                options: [
                  {
                    name: '_160_GRAMS',
                    title: 'Extra stevig, 160 grams',
                    disabledWhen: [],
                    priceKey: 'afwerking'
                  },
                  {
                    name: '_120_GRAMS',
                    title: 'Stevig 120 grams',
                    disabledWhen: [],
                    priceKey: 'afwerking'
                  },
                  {
                    name: 'NONE',
                    title: 'Gelijk aan binnenwerk',
                    disabledWhen: [],
                    priceKey: 'afwerking'
                  }
                ]
              }
            ]
          },
          {
            title: 'Afwerking',
            description: '',
            optionGroups: [
              {
                name: 'bindwijze',
                productionCategory: 'Afwerking',
                default: 'VOUWEN_NIETEN',
                options: [
                  {
                    name: 'VOUWEN_NIETEN',
                    title: 'Vouwen en nieten',
                    disabledWhen: [],
                    priceKey: 'afwerking'
                  }
                ]
              },
              {
                name: 'schoonsnijden',
                productionCategory: 'Afwerking',
                default: 'SCHOONSNIJDEN',
                options: [
                  {
                    name: 'SCHOONSNIJDEN',
                    title: 'Schoonsnijden',
                    disabledWhen: [],
                    priceKey: 'orderafwerking'
                  },
                  {
                    name: 'NONE',
                    title: 'Niet schoonsnijden',
                    disabledWhen: [],
                    priceKey: 'orderafwerking'
                  }
                ]
              }
            ]
          },
          {
            title: 'Opmerking',
            description:
              'Plaats hier eventuele bijzonderheden met betrekking tot de geselecteerde bestanden.',
            optionGroups: [
              {
                name: 'opmerking',
                productionCategory: 'Opmerking'
              }
            ]
          }
        ]
      },
      //flyer
      {
        title: 'Flyer',
        image: 'default/flyer.svg',
        menus: [
          {
            title: 'Printopties',
            description: '',
            optionGroups: [
              {
                name: 'formaat',
                productionCategory: 'Printopties',
                default: 'A5',
                options: [
                  {
                    name: 'A4',
                    title: 'A4',
                    priceKey: 'formaat'
                  },
                  {
                    name: 'A5',
                    title: 'A5',
                    priceKey: 'formaat'
                  },
                  {
                    name: 'A6',
                    title: 'A6',
                    priceKey: 'formaat'
                  }
                ]
              },
              {
                name: 'printkleur',
                productionCategory: 'Printopties',
                default: 'KLEUR',
                analyseValue: true,
                options: [
                  {
                    name: 'KLEUR',
                    title: 'Kleur',
                    priceKey: 'printkleur',
                    disabledWhen: []
                  },
                  {
                    name: 'ZWART_WIT',
                    title: 'Zwart / wit',
                    priceKey: 'printkleur',
                    disabledWhen: []
                  }
                ]
              },
              {
                name: 'printwijze',
                productionCategory: 'Printopties',
                default: 'Enkelzijdig',
                options: [
                  {
                    priceKey: 'printwijze',
                    name: 'Enkelzijdig',
                    title: 'Enkelzijdig',
                    disabledWhen: []
                  },
                  {
                    priceKey: 'printwijze',
                    name: 'Dubbelzijdig',
                    title: 'Dubbelzijdig',
                    disabledWhen: []
                  }
                ]
              },
              {
                name: 'papierType',
                productionCategory: 'Printopties',
                default: '_160_GRAMS',
                options: [
                  {
                    name: '_80_GRAMS',
                    title: '80 grams',
                    disabledWhen: [],
                    priceKey: 'papierType'
                  },
                  {
                    name: '_100_GRAMS',
                    title: '100 grams',
                    disabledWhen: [],
                    priceKey: 'papierType'
                  },
                  {
                    name: '_120_GRAMS',
                    title: '120 grams',
                    disabledWhen: [],
                    priceKey: 'papierType'
                  },
                  {
                    name: '_160_GRAMS',
                    title: '160 grams',
                    disabledWhen: [],
                    priceKey: 'papierType'
                  },
                  {
                    name: '_200_GRAMS',
                    title: '200 grams',
                    disabledWhen: [],
                    priceKey: 'papierType'
                  },
                  {
                    name: '_250_GRAMS',
                    title: '250 grams',
                    disabledWhen: [],
                    priceKey: 'papierType'
                  },
                  {
                    name: '_300_GRAMS',
                    title: '300 grams',
                    disabledWhen: [],
                    priceKey: 'papierType'
                  }
                ]
              }
            ]
          },
          {
            title: 'Afwerking',
            description: '',
            optionGroups: [
              {
                name: 'plastificeren',
                productionCategory: 'Afwerking',
                default: 'NONE',
                options: [
                  {
                    name: 'NONE',
                    title: 'Niet plastificeren',
                    disabledWhen: [],
                    priceKey: 'plastificeren'
                  },
                  {
                    name: 'PLASTIFICEREN_GLANS',
                    title: 'Plastificeren glans',
                    priceKey: 'plastificeren'
                  },
                  {
                    name: 'PLASTIFICEREN_MAT',
                    title: 'Plastificeren mat',
                    priceKey: 'plastificeren'
                  }
                ]
              },
              {
                name: 'schoonsnijden',
                productionCategory: 'Afwerking',
                default: 'SCHOONSNIJDEN',
                options: [
                  {
                    name: 'SCHOONSNIJDEN',
                    title: 'Schoonsnijden',
                    disabledWhen: [],
                    priceKey: 'orderafwerking'
                  },
                  {
                    name: 'NONE',
                    title: 'Niet schoonsnijden',
                    disabledWhen: [],
                    priceKey: 'orderafwerking'
                  }
                ]
              }
            ]
          },
          {
            title: 'Opmerking',
            description:
              'Plaats hier eventuele bijzonderheden met betrekking tot de geselecteerde bestanden.',
            optionGroups: [
              {
                name: 'opmerking',
                productionCategory: 'Opmerking'
              }
            ]
          }
        ]
      },
      //poster
      {
        title: 'Poster',
        image: 'default/poster.svg',
        menus: [
          {
            title: 'Printopties',
            description: '',
            optionGroups: [
              {
                name: 'formaat',
                productionCategory: 'Printopties',
                default: 'A0',
                options: [
                  {
                    priceKey: 'formaat',
                    name: 'A0',
                    title: 'A0',
                    disabledWhen: []
                  },
                  {
                    priceKey: 'formaat',
                    name: 'B0',
                    title: 'B0',
                    disabledWhen: []
                  },
                  {
                    priceKey: 'formaat',
                    name: 'A1',
                    title: 'A1',
                    disabledWhen: []
                  },
                  {
                    priceKey: 'formaat',
                    name: 'B1',
                    title: 'B1',
                    disabledWhen: []
                  },
                  {
                    priceKey: 'formaat',
                    name: 'A2',
                    title: 'A2',
                    disabledWhen: []
                  },
                  {
                    priceKey: 'formaat',
                    name: 'ALS_BESTAND',
                    title: 'Als bestand',
                    disabledWhen: []
                  }
                ]
              },
              {
                name: 'printkleur',
                productionCategory: 'Printopties',
                default: 'KLEUR',
                analyseValue: true,
                options: [
                  {
                    name: 'KLEUR',
                    title: 'Kleur',
                    priceKey: 'printkleur',
                    disabledWhen: []
                  },
                  {
                    name: 'ZWART_WIT',
                    title: 'Zwart / wit',
                    priceKey: 'printkleur',
                    disabledWhen: []
                  }
                ]
              },
              {
                name: 'papierType',
                productionCategory: 'Printopties',
                default: '_150_GRAMS_GLANS',
                options: [
                  {
                    name: '_150_GRAMS_GLANS',
                    title: '150 grams glans',
                    disabledWhen: [],
                    priceKey: 'papierType'
                  },
                  {
                    name: '_150_GRAMS_MAT',
                    title: '150 grams mat',
                    disabledWhen: [],
                    priceKey: 'papierType'
                  }
                ]
              }
            ]
          },
          {
            title: 'Afwerking',
            description: '',
            optionGroups: [
              {
                name: 'plastificeren',
                productionCategory: 'Afwerking',
                default: 'NONE',
                options: [
                  {
                    name: 'NONE',
                    title: 'Niet plastificeren',
                    disabledWhen: [],
                    priceKey: 'plastificeren'
                  },
                  {
                    name: 'PLASTIFICEREN_GLANS',
                    title: 'Plastificeren glans',
                    disabledWhen: ['A4_VOUWEN'],
                    priceKey: 'plastificeren'
                  },
                  {
                    name: 'PLASTIFICEREN_MAT',
                    title: 'Plastificeren mat',
                    disabledWhen: ['A4_VOUWEN'],
                    priceKey: 'plastificeren'
                  }
                ]
              },
              {
                name: 'schoonsnijden',
                productionCategory: 'Afwerking',
                default: 'SCHOONSNIJDEN',
                options: [
                  {
                    name: 'SCHOONSNIJDEN',
                    title: 'Schoonsnijden',
                    disabledWhen: [],
                    priceKey: 'orderafwerking'
                  },
                  {
                    name: 'NONE',
                    title: 'Niet schoonsnijden',
                    disabledWhen: [],
                    priceKey: 'orderafwerking'
                  }
                ]
              }
            ]
          },
          {
            title: 'Opmerking',
            description:
              'Plaats hier eventuele bijzonderheden met betrekking tot de geselecteerde bestanden.',
            optionGroups: [
              {
                name: 'opmerking',
                productionCategory: 'Opmerking'
              }
            ]
          },
          {
            title: 'Bedrukking',
            hidden: true,
            optionGroups: [
              {
                name: 'printwijze',
                productionCategory: 'Printopties',
                default: 'Enkelzijdig',
                options: [
                  {
                    priceKey: 'printwijze',
                    name: 'Enkelzijdig',
                    title: 'Enkelzijdig',
                    disabledWhen: []
                  }
                ]
              }
            ]
          }
        ]
      },
      //PRESENTATIE PANEEL
      {
        title: 'Presentatie paneel',
        image: 'default/presentatie-paneel.svg',
        menus: [
          {
            title: 'Printopties',
            description: '',
            optionGroups: [
              {
                name: 'formaat',
                productionCategory: 'Printopties',
                default: 'A5',
                options: [
                  {
                    name: 'A0',
                    title: 'A0',
                    priceKey: 'formaat'
                  },
                  {
                    name: 'B0',
                    title: 'B0',
                    priceKey: 'formaat'
                  },
                  {
                    name: 'A1',
                    title: 'A1',
                    priceKey: 'formaat'
                  },
                  {
                    name: 'B1',
                    title: 'B1',
                    priceKey: 'formaat'
                  },
                  {
                    name: 'A2',
                    title: 'A2',
                    priceKey: 'formaat'
                  },
                  {
                    name: 'A3',
                    title: 'A3',
                    priceKey: 'formaat'
                  },
                  {
                    name: 'A4',
                    title: 'A4',
                    priceKey: 'formaat'
                  },
                  {
                    name: 'A5',
                    title: 'A5',
                    priceKey: 'formaat'
                  },
                  {
                    name: 'A6',
                    title: 'A6',
                    priceKey: 'formaat'
                  },
                  {
                    name: 'ALS_BESTAND',
                    title: 'Als bestand',
                    priceKey: 'formaat'
                  }
                ]
              },
              {
                name: 'papierType',
                productionCategory: 'Printopties',
                default: 'HONINGRAATKARTON_10_MM',
                options: [
                  {
                    name: 'HONINGRAATKARTON_10_MM',
                    title: 'Honingraatkarton 10 mm FSC',
                    disabledWhen: [],
                    priceKey: 'papierType'
                  },
                  {
                    name: 'FOAMBOARD_5_MM',
                    title: 'Foamboard 5mm',
                    disabledWhen: [],
                    priceKey: 'papierType'
                  },
                  {
                    name: 'FOAMBOARD_10_MM',
                    title: 'Foamboard 10mm',
                    disabledWhen: [],
                    priceKey: 'papierType'
                  },
                  {
                    name: 'FOREX_3_MM',
                    title: 'Recycled kunststof wit 3mm (Forex)',
                    disabledWhen: [],
                    priceKey: 'papierType'
                  },
                  {
                    name: 'FOREX_5_MM',
                    title: 'Recycled kunststof wit 5mm (Forex)',
                    disabledWhen: [],
                    priceKey: 'papierType'
                  },
                  {
                    name: 'DIBOND_3_MM',
                    title: 'Aluminium sandwichplaat (Dibond)',
                    disabledWhen: [],
                    priceKey: 'papierType'
                  },
                  {
                    name: 'ACRYLAAT_HELDER_5_MM',
                    title: 'Recycled Acrylaat helder 5mm',
                    disabledWhen: [],
                    priceKey: 'papierType'
                  },
                  {
                    name: 'SCHEURVAST_1_2_MM',
                    title: 'Scheurvast kunststof 1,2mm',
                    disabledWhen: [],
                    priceKey: 'papierType'
                  }
                ]
              }
            ]
          },
          {
            title: 'Afwerking',
            description: '',
            optionGroups: [
              {
                name: 'schoonsnijden',
                productionCategory: 'Afwerking',
                default: 'SCHOONSNIJDEN',
                options: [
                  {
                    name: 'SCHOONSNIJDEN',
                    title: 'Schoonsnijden',
                    disabledWhen: [],
                    priceKey: 'orderafwerking'
                  },
                  {
                    name: 'NONE',
                    title: 'Niet schoonsnijden',
                    disabledWhen: [],
                    priceKey: 'orderafwerking'
                  }
                ]
              }
            ]
          },
          {
            title: 'Opmerking',
            description:
              'Plaats hier eventuele bijzonderheden met betrekking tot de geselecteerde bestanden.',
            optionGroups: [
              {
                name: 'opmerking',
                productionCategory: 'Opmerking'
              }
            ]
          }
        ]
      },
      //roll-up banner
      {
        title: 'Roll-up banner',
        image: 'default/banner.svg',
        menus: [
          {
            title: 'Printopties',
            description: '',
            optionGroups: [
              {
                name: 'formaat',
                productionCategory: 'Printopties',
                default: '_85CM',
                options: [
                  {
                    priceKey: 'formaat',
                    name: '_100CM',
                    title: '100cm breed',
                    disabledWhen: []
                  },
                  {
                    priceKey: 'formaat',
                    name: '_85CM',
                    title: '85cm breed',
                    disabledWhen: []
                  }
                ]
              },
              {
                name: 'printkleur',
                productionCategory: 'Printopties',
                default: 'KLEUR',
                analyseValue: true,
                options: [
                  {
                    name: 'KLEUR',
                    title: 'Kleur',
                    priceKey: 'printkleur',
                    disabledWhen: []
                  },
                  {
                    name: 'ZWART_WIT',
                    title: 'Zwart / wit',
                    priceKey: 'printkleur',
                    disabledWhen: []
                  }
                ]
              }
            ]
          },
          {
            title: 'Banner systeem',
            description: '',
            optionGroups: [
              {
                name: 'papierType',
                productionCategory: 'Banner systeem',
                default: 'ROLL_UP_STANDAARD',
                options: [
                  {
                    name: 'ROLL_UP_STANDAARD',
                    title: 'Roll-up standaard, 210cm hoog',
                    disabledWhen: [],
                    priceKey: 'papierType'
                  },
                  {
                    name: 'ROLL_UP_DELUXE',
                    title: 'Roll-up deluxe, 160-210cm hoog',
                    disabledWhen: [],
                    priceKey: 'papierType'
                  }
                ]
              }
            ]
          },
          {
            title: 'Opmerking',
            description:
              'Plaats hier eventuele bijzonderheden met betrekking tot de geselecteerde bestanden.',
            optionGroups: [
              {
                name: 'opmerking',
                productionCategory: 'Opmerking'
              }
            ]
          },
          {
            title: 'Bedrukking',
            hidden: true,
            optionGroups: [
              {
                name: 'printwijze',
                productionCategory: 'Opmerking',
                default: 'Enkelzijdig',
                options: [
                  {
                    priceKey: 'printwijze',
                    name: 'Enkelzijdig',
                    title: 'Enkelzijdig',
                    disabledWhen: []
                  }
                ]
              }
            ]
          }
        ]
      }
      /*       //visitekaartjes
      {
        title: 'Visitekaartjes',
        image: 'default/visitekaartjes.svg',
        menus: [
          {
            title: 'Staffel',
            description: '',
            optionGroups: [
              {
                name: 'staffel',
                productionCategory: 'Staffel',
                default: '_100',
                options: [
                  {
                    name: '_100',
                    priceKey: 'staffel',
                    title: '100 kaartjes'
                  },
                  {
                    name: '_500',
                    priceKey: 'staffel',
                    title: '500 kaartjes'
                  }
                ]
              }
            ]
          },
          {
            title: 'Printopties',
            description: '',
            optionGroups: [
              {
                name: 'formaat',
                productionCategory: 'Printopties',
                default: 'A4',
                options: [
                  {
                    name: 'A4',
                    title: '85mm x 55mm',
                    priceKey: 'formaat'
                  }
                ]
              },
              {
                name: 'printkleur',
                productionCategory: 'Printopties',
                default: 'KLEUR',
                analyseValue: true,
                options: [
                  {
                    name: 'KLEUR',
                    title: 'Kleur',
                    priceKey: 'printkleur',
                    disabledWhen: []
                  },
                  {
                    name: 'ZWART_WIT',
                    title: 'Zwart / wit',
                    priceKey: 'printkleur',
                    disabledWhen: []
                  }
                ]
              },
              {
                name: 'printwijze',
                productionCategory: 'Printopties',
                default: 'Dubbelzijdig',
                options: [
                  {
                    priceKey: 'printwijze',
                    name: 'Enkelzijdig',
                    title: 'Enkelzijdig',
                    disabledWhen: []
                  },
                  {
                    priceKey: 'printwijze',
                    name: 'Dubbelzijdig',
                    title: 'Dubbelzijdig',
                    disabledWhen: []
                  }
                ]
              },
              {
                name: 'papierType',
                productionCategory: 'Printopties',
                default: '_300_GRAMS_WIT',
                options: [
                  {
                    name: '_300_GRAMS_WIT',
                    title: '300 grams wit',
                    disabledWhen: [],
                    priceKey: 'papierType'
                  },
                  {
                    name: '_300_GRAMS_OFF_WHITE',
                    title: '300 grams off-white',
                    disabledWhen: [],
                    priceKey: 'papierType'
                  }
                ]
              }
            ]
          },
          {
            title: 'Opmerking',
            description:
              'Plaats hier eventuele bijzonderheden met betrekking tot de geselecteerde bestanden.',
            optionGroups: [
              {
                name: 'opmerking',
                productionCategory: 'Opmerking'
              }
            ]
          }
        ]
      } */
    ],
    productsSecured: [
      //zelf samenstellen
      {
        image: 'default/sliders.svg',
        title: 'Zelf samenstellen',
        menus: [
          {
            title: 'Printopties',
            description: '',
            optionGroups: [
              {
                name: 'formaat',
                productionCategory: 'Printopties',
                default: 'A4',
                analyseValue: true,
                options: [
                  {
                    priceKey: 'formaat',
                    name: 'A3',
                    title: 'A3',
                    disabledWhen: []
                  },
                  {
                    priceKey: 'formaat',
                    name: 'A4',
                    title: 'A4',
                    disabledWhen: []
                  },
                  {
                    priceKey: 'formaat',
                    name: 'A5',
                    title: 'A5',
                    disabledWhen: []
                  },
                  {
                    priceKey: 'formaat',
                    name: 'A6',
                    title: 'A6',
                    disabledWhen: []
                  },
                  {
                    priceKey: 'formaat',
                    name: 'ALS_BESTAND',
                    title: 'Als bestand',
                    disabledWhen: []
                  }
                ]
              },
              {
                name: 'printkleur',
                productionCategory: 'Printopties',
                default: 'ZWART_WIT',
                analyseValue: true,
                options: [
                  {
                    name: 'KLEUR',
                    title: 'Kleur',
                    priceKey: 'printkleur',
                    disabledWhen: []
                  },
                  {
                    name: 'ZWART_WIT',
                    title: 'Zwart / wit',
                    priceKey: 'printkleur',
                    disabledWhen: []
                  }
                ]
              },
              {
                name: 'printwijze',
                productionCategory: 'Printopties',
                default: 'Dubbelzijdig',
                options: [
                  {
                    priceKey: 'printwijze',
                    name: 'Enkelzijdig',
                    title: 'Enkelzijdig',
                    disabledWhen: []
                  },
                  {
                    priceKey: 'printwijze',
                    name: 'Dubbelzijdig',
                    title: 'Dubbelzijdig'
                  }
                ]
              },
              {
                name: 'papierType',
                productionCategory: 'Printopties',
                default: '_100_GRAMS',
                options: [
                  {
                    name: 'Standaard papier',
                    title: 'Standaard papier',
                    subOptions: [
                      {
                        name: '_80_GRAMS',
                        priceKey: 'papierType',
                        title: '80 Grams papier'
                      },
                      {
                        name: '_100_GRAMS',
                        priceKey: 'papierType',
                        title: '100 Grams papier'
                      },
                      {
                        name: '_120_GRAMS',
                        priceKey: 'papierType',
                        title: '120 Grams papier'
                      },
                      {
                        name: '_160_GRAMS',
                        priceKey: 'papierType',
                        title: '160 Grams papier'
                      },
                      {
                        name: '_200_GRAMS',
                        priceKey: 'papierType',
                        title: '200 Grams papier'
                      },
                      {
                        name: '_250_GRAMS',
                        priceKey: 'papierType',
                        title: '250 Grams papier'
                      },
                      {
                        name: '_300_GRAMS',
                        priceKey: 'papierType',
                        title: '300 Grams papier'
                      }
                    ]
                  },
                  {
                    name: 'MC Gloss',
                    title: 'MC Gloss papier',
                    subOptions: [
                      {
                        name: 'MC_GLOSS_115G',
                        priceKey: 'papierType',
                        title: 'MC Gloss 115g'
                      },
                      {
                        name: 'MC_GLOSS_150G',
                        priceKey: 'papierType',
                        title: 'MC Gloss 150g'
                      },
                      {
                        name: 'MC_GLOSS_200G',
                        priceKey: 'papierType',
                        title: 'MC Gloss 200g'
                      },
                      {
                        name: 'MC_GLOSS_250G',
                        priceKey: 'papierType',
                        title: 'MC Gloss 250g'
                      }
                    ]
                  },
                  {
                    name: 'Off white',
                    title: 'Off white papier',
                    subOptions: [
                      {
                        name: 'OFF_WHITE_80G',
                        priceKey: 'papierType',
                        title: 'Off-white 80g'
                      },
                      {
                        name: 'OFF_WHITE_100G',
                        priceKey: 'papierType',
                        title: 'Off-white 100g'
                      },
                      {
                        name: 'OFF_WHITE_200G',
                        priceKey: 'papierType',
                        title: 'Off-white 200g'
                      },
                      {
                        name: 'OFF_WHITE_300G',
                        priceKey: 'papierType',
                        title: 'Off-white 300g'
                      }
                    ]
                  },
                  {
                    name: 'Sticker',
                    title: 'Sticker',
                    subOptions: [
                      {
                        name: 'PERMANENTE_STICKER',
                        priceKey: 'papierType',
                        title: 'Permanente sticker',
                        disabledWhen: []
                      },
                      {
                        name: 'VERWIJDERBARE_STICKER',
                        priceKey: 'papierType',
                        title: 'Verwijderbare sticker',
                        disabledWhen: []
                      }
                    ]
                  },
                  {
                    name: 'TYVEK_75G',
                    priceKey: 'papierType',
                    title: 'Tyvek 75g'
                  }
                ]
              }
            ]
          },
          {
            title: 'Afwerking',
            description: '',
            optionGroups: [
              {
                name: 'afwerking',
                productionCategory: 'Afwerking',
                default: 'NONE',
                options: [
                  {
                    name: 'NONE',
                    priceKey: 'afwerking',
                    title: 'Geen afwerking'
                  },
                  {
                    name: 'VOUWEN',
                    priceKey: 'afwerking',
                    title: 'Vouwen'
                  },
                  {
                    name: 'ROLLEN',
                    priceKey: 'afwerking',
                    title: 'Rollen'
                  },
                  {
                    name: 'Boren',
                    title: 'Boren',
                    subOptions: [
                      {
                        name: 'BOREN_2_GATEN',
                        priceKey: 'afwerking',
                        title: 'Boren 2 gaten'
                      },
                      {
                        name: 'BOREN_4_GATEN',
                        priceKey: 'afwerking',
                        title: 'Boren 4 gaten'
                      }
                    ]
                  },
                  {
                    name: 'Plastificeren',
                    title: 'Plastificeren',
                    subOptions: [
                      {
                        name: 'PLASTIFICEREN_MAT',
                        priceKey: 'afwerking',
                        title: 'Plastificeren mat'
                      },
                      {
                        name: 'PLASTIFICEREN_GLANS',
                        priceKey: 'afwerking',
                        title: 'Plastificeren glans'
                      }
                    ]
                  }
                ]
              },
              {
                name: 'bindwijze',
                productionCategory: 'Afwerking',
                default: 'NONE',
                options: [
                  {
                    name: 'Nieten',
                    title: 'Nieten',
                    hideWhen: ['ROLLEN'],
                    subOptions: [
                      {
                        name: 'NIETEN_1_NIETJE',
                        priceKey: 'bindwijze',
                        title: 'Nieten 1 nietje'
                      },
                      {
                        name: 'NIETEN_2_NIETJES',
                        priceKey: 'bindwijze',
                        title: 'Nieten 2 nietjes'
                      }
                    ]
                  },
                  {
                    name: 'Ringband',
                    title: 'Ringband',
                    hideWhen: ['ROLLEN'],
                    subOptions: [
                      {
                        name: 'WIRE_O',
                        priceKey: 'bindwijze',
                        title: 'Ringband metaal'
                      },
                      {
                        name: 'WIRE_O_TRANSPARANT_VOOR_KARTON_ACHTER',
                        priceKey: 'bindwijze',
                        title:
                          'Ringband metaal, transparant voor, karton achter'
                      },
                      {
                        name: 'WIRE_O_TRANSPARANT_VOOR_EN_ACHTER',
                        priceKey: 'bindwijze',
                        title: 'Ringband metaal, transparant voor en achter'
                      },
                      {
                        name: 'PLASTIC_BINDRUG',
                        priceKey: 'bindwijze',
                        title: 'Ringband plastic'
                      },
                      {
                        name: 'PLASTIC_BINDRUG_TRANSPARANT_VOOR_KARTON_ACHTER',
                        priceKey: 'bindwijze',
                        title:
                          'Ringband plastic, transparant voor, karton achter'
                      },
                      {
                        name: 'PLASTIC_BINDRUG_TRANSPARANT_VOOR_EN_ACHTER',
                        priceKey: 'bindwijze',
                        title: 'Ringband plastic, transparant voor en achter'
                      }
                    ]
                  },
                  {
                    name: 'BUIS_BINDER',
                    priceKey: 'bindwijze',
                    title: 'Buis binder'
                  },
                  {
                    name: 'NONE',
                    priceKey: 'bindwijze',
                    title: 'Geen bindwijze'
                  }
                ]
              }
            ]
          },
          {
            title: 'Opmerking',
            description:
              'Plaats hier eventuele bijzonderheden met betrekking tot de geselecteerde bestanden.',
            optionGroups: [
              {
                name: 'opmerking',
                productionCategory: 'Opmerking'
              }
            ]
          }
        ]
      },
      //boekje
      {
        title: 'Boekje',
        image: 'default/boekje.svg',
        menus: [
          {
            title: 'Printopties',
            description: '',
            optionGroups: [
              {
                name: 'formaat',
                productionCategory: 'Printopties',
                default: 'A4',
                options: [
                  {
                    name: 'A3',
                    title: 'A3',
                    priceKey: 'formaat'
                  },
                  {
                    name: 'A4',
                    title: 'A4',
                    priceKey: 'formaat'
                  },
                  {
                    name: 'A5',
                    title: 'A5',
                    priceKey: 'formaat'
                  }
                ]
              },
              {
                name: 'printkleur',
                productionCategory: 'Printopties',
                default: 'KLEUR',
                analyseValue: true,
                options: [
                  {
                    name: 'KLEUR',
                    title: 'Kleur',
                    priceKey: 'printkleur',
                    disabledWhen: []
                  },
                  {
                    name: 'ZWART_WIT',
                    title: 'Zwart / wit',
                    priceKey: 'printkleur',
                    disabledWhen: []
                  }
                ]
              },
              {
                name: 'printwijze',
                productionCategory: 'Printopties',
                default: 'Dubbelzijdig',
                options: [
                  {
                    priceKey: 'printwijze',
                    name: 'Enkelzijdig',
                    title: 'Enkelzijdig',
                    disabledWhen: []
                  },
                  {
                    priceKey: 'printwijze',
                    name: 'Dubbelzijdig',
                    title: 'Dubbelzijdig',
                    disabledWhen: []
                  }
                ]
              },
              {
                name: 'papierType',
                productionCategory: 'Printopties',
                default: '_100_GRAMS',
                options: [
                  {
                    name: '_80_GRAMS',
                    title: '80 grams',
                    disabledWhen: [],
                    priceKey: 'papierType'
                  },
                  {
                    name: '_100_GRAMS',
                    title: '100 grams',
                    disabledWhen: [],
                    priceKey: 'papierType'
                  },
                  {
                    name: '_120_GRAMS',
                    title: '120 grams',
                    disabledWhen: [],
                    priceKey: 'papierType'
                  }
                ]
              }
            ]
          },

          {
            title: 'Voorkant',
            description: '',
            optionGroups: [
              {
                name: 'papier',
                priceObjectKey: 'voorzijde',
                productionCategory: 'Voorkant',
                default: 'BEDRUKT_STEVIG',
                options: [
                  {
                    name: 'BEDRUKT_STANDAARD',
                    title: 'Standaard (100 grams)',
                    disabledWhen: [],
                    priceKey: 'afwerking'
                  },
                  {
                    name: 'BEDRUKT_STEVIG',
                    title: 'Extra stevig (200 grams)',
                    disabledWhen: [],
                    priceKey: 'afwerking'
                  }
                ]
              },
              {
                name: 'transparant',
                productionCategory: 'Voorkant',
                default: 'TRANSPARANT_PLASTIC',
                options: [
                  {
                    name: 'TRANSPARANT_PLASTIC',
                    title: 'Transparante voorzijde',
                    disabledWhen: [],
                    priceKey: 'afwerking'
                  },
                  {
                    name: 'NONE',
                    title: 'Geen transparante voorzijde',
                    disabledWhen: [],
                    priceKey: 'afwerking'
                  }
                ]
              }
            ]
          },

          {
            title: 'Achterkant',
            description: '',
            optionGroups: [
              {
                name: 'afwerking',
                priceObjectKey: 'achterzijde',
                productionCategory: 'Achterkant',
                default: 'BEDRUKT_STEVIG',
                options: [
                  {
                    name: 'BEDRUKT_STANDAARD',
                    title: 'Bedrukt, standaard (100 grams)',
                    disabledWhen: [],
                    priceKey: 'afwerking'
                  },
                  {
                    name: 'BEDRUKT_STEVIG',
                    title: 'Bedrukt, extra stevig (200 grams)',
                    disabledWhen: [],
                    priceKey: 'afwerking'
                  },
                  {
                    name: 'BLANCO_STEVIG',
                    title: 'Blanco, extra stevig (200 grams)',
                    disabledWhen: [],
                    priceKey: 'afwerking'
                  }
                ]
              },
              {
                name: 'transparant',
                productionCategory: 'Achterkant',
                default: 'TRANSPARANT_PLASTIC',
                options: [
                  {
                    name: 'TRANSPARANT_PLASTIC',
                    title: 'Transparante achterzijde',
                    disabledWhen: [],
                    priceKey: 'afwerking'
                  },
                  {
                    name: 'NONE',
                    title: 'Geen transparante achterzijde',
                    disabledWhen: [],
                    priceKey: 'afwerking'
                  }
                ]
              }
            ]
          },
          {
            title: 'Afwerking',
            description: '',
            optionGroups: [
              {
                name: 'bindwijze',
                productionCategory: 'Afwerking',
                default: 'WIRE_O',
                options: [
                  {
                    name: 'WIRE_O',
                    priceKey: 'bindwijze',
                    title: 'Ringband metaal'
                  },
                  {
                    name: 'PLASTIC_BINDRUG',
                    priceKey: 'bindwijze',
                    title: 'Ringband plastic'
                  },
                  {
                    name: 'SNELHECHTER',
                    priceKey: 'bindwijze',
                    title: 'Snelhechter'
                  }
                ]
              },
              {
                name: 'bindzijde',
                productionCategory: 'Afwerking',
                default: 'LANGE_ZIJDE',
                options: [
                  {
                    name: 'LANGE_ZIJDE',
                    priceKey: 'bindzijde',
                    title: 'Inbinden aan lange zijde'
                  },
                  {
                    name: 'KORTE_ZIJDE',
                    priceKey: 'bindzijde',
                    title: 'Inbinden aan korte zijde'
                  }
                ]
              },
              {
                name: 'schoonsnijden',
                productionCategory: 'Afwerking',
                default: 'SCHOONSNIJDEN',
                options: [
                  {
                    name: 'SCHOONSNIJDEN',
                    title: 'Schoonsnijden',
                    disabledWhen: [],
                    priceKey: 'orderafwerking'
                  },
                  {
                    name: 'NONE',
                    title: 'Niet schoonsnijden',
                    disabledWhen: [],
                    priceKey: 'orderafwerking'
                  }
                ]
              }
            ]
          },
          {
            title: 'Opmerking',
            description:
              'Plaats hier eventuele bijzonderheden met betrekking tot de geselecteerde bestanden.',
            optionGroups: [
              {
                name: 'opmerking',
                productionCategory: 'Opmerking'
              }
            ]
          }
        ]
      },
      //brochure
      {
        title: 'Brochure',
        image: 'default/brochure.svg',
        menus: [
          {
            title: 'Printopties',
            description: '',
            optionGroups: [
              {
                name: 'formaat',
                productionCategory: 'Printopties',
                default: 'A4',
                options: [
                  {
                    name: 'A4',
                    title: 'A4',
                    priceKey: 'formaat'
                  },
                  {
                    name: 'A5',
                    title: 'A5',
                    priceKey: 'formaat'
                  }
                ]
              },
              {
                name: 'printkleur',
                productionCategory: 'Printopties',
                default: 'KLEUR',
                analyseValue: true,
                options: [
                  {
                    name: 'KLEUR',
                    title: 'Kleur',
                    priceKey: 'printkleur',
                    disabledWhen: []
                  },
                  {
                    name: 'ZWART_WIT',
                    title: 'Zwart / wit',
                    priceKey: 'printkleur',
                    disabledWhen: []
                  }
                ]
              },
              {
                name: 'printwijze',
                productionCategory: 'Printopties',
                default: 'Dubbelzijdig',
                options: [
                  {
                    priceKey: 'printwijze',
                    name: 'Enkelzijdig',
                    title: 'Enkelzijdig',
                    disabledWhen: []
                  },
                  {
                    priceKey: 'printwijze',
                    name: 'Dubbelzijdig',
                    title: 'Dubbelzijdig',
                    disabledWhen: []
                  }
                ]
              },
              {
                name: 'papierType',
                productionCategory: 'Printopties',
                default: '_100_GRAMS',
                options: [
                  {
                    name: '_80_GRAMS',
                    title: '80 grams',
                    disabledWhen: [],
                    priceKey: 'papierType'
                  },
                  {
                    name: '_100_GRAMS',
                    title: '100 grams',
                    disabledWhen: [],
                    priceKey: 'papierType'
                  },
                  {
                    name: '_120_GRAMS',
                    title: '120 grams',
                    disabledWhen: [],
                    priceKey: 'papierType'
                  }
                ]
              }
            ]
          },
          {
            title: 'Omslag',
            description: '',
            optionGroups: [
              {
                name: 'omslagBedrukking',
                productionCategory: 'Omslag',
                default: 'BEDRUKT_VOOR_EN_ACHTER',
                options: [
                  {
                    name: 'BEDRUKT_VOOR_EN_ACHTER',
                    title: 'Voor- en achterzijde bedrukt',
                    disabledWhen: [],
                    priceKey: 'afwerking'
                  },
                  {
                    name: 'BEDRUKT_PAGINA_1_EN_2',
                    title: 'Pagina 1 en 2 bedrukt',
                    disabledWhen: [],
                    priceKey: 'afwerking'
                  },
                  {
                    name: 'BEDRUKT_VOORZIJDE',
                    title: 'Alleen voorzijde bedrukt',
                    disabledWhen: [],
                    priceKey: 'afwerking'
                  }
                ]
              },
              {
                name: 'omslagPapier',
                productionCategory: 'Omslag',
                default: '_160_GRAMS',
                options: [
                  {
                    name: '_160_GRAMS',
                    title: 'Extra stevig, 160 grams',
                    disabledWhen: [],
                    priceKey: 'afwerking'
                  },
                  {
                    name: '_120_GRAMS',
                    title: 'Stevig 120 grams',
                    disabledWhen: [],
                    priceKey: 'afwerking'
                  },
                  {
                    name: 'NONE',
                    title: 'Gelijk aan binnenwerk',
                    disabledWhen: [],
                    priceKey: 'afwerking'
                  }
                ]
              }
            ]
          },
          {
            title: 'Afwerking',
            description: '',
            optionGroups: [
              {
                name: 'bindwijze',
                productionCategory: 'Afwerking',
                default: 'VOUWEN_NIETEN',
                options: [
                  {
                    name: 'VOUWEN_NIETEN',
                    title: 'Vouwen en nieten',
                    disabledWhen: [],
                    priceKey: 'afwerking'
                  }
                ]
              },
              {
                name: 'schoonsnijden',
                productionCategory: 'Afwerking',
                default: 'SCHOONSNIJDEN',
                options: [
                  {
                    name: 'SCHOONSNIJDEN',
                    title: 'Schoonsnijden',
                    disabledWhen: [],
                    priceKey: 'orderafwerking'
                  },
                  {
                    name: 'NONE',
                    title: 'Niet schoonsnijden',
                    disabledWhen: [],
                    priceKey: 'orderafwerking'
                  }
                ]
              }
            ]
          },
          {
            title: 'Opmerking',
            description:
              'Plaats hier eventuele bijzonderheden met betrekking tot de geselecteerde bestanden.',
            optionGroups: [
              {
                name: 'opmerking',
                productionCategory: 'Opmerking'
              }
            ]
          }
        ]
      },
      //flyer
      {
        title: 'Flyer',
        image: 'default/flyer.svg',
        menus: [
          {
            title: 'Printopties',
            description: '',
            optionGroups: [
              {
                name: 'formaat',
                productionCategory: 'Printopties',
                default: 'A5',
                options: [
                  {
                    name: 'A4',
                    title: 'A4',
                    priceKey: 'formaat'
                  },
                  {
                    name: 'A5',
                    title: 'A5',
                    priceKey: 'formaat'
                  },
                  {
                    name: 'A6',
                    title: 'A6',
                    priceKey: 'formaat'
                  }
                ]
              },
              {
                name: 'printkleur',
                productionCategory: 'Printopties',
                default: 'KLEUR',
                analyseValue: true,
                options: [
                  {
                    name: 'KLEUR',
                    title: 'Kleur',
                    priceKey: 'printkleur',
                    disabledWhen: []
                  },
                  {
                    name: 'ZWART_WIT',
                    title: 'Zwart / wit',
                    priceKey: 'printkleur',
                    disabledWhen: []
                  }
                ]
              },
              {
                name: 'printwijze',
                productionCategory: 'Printopties',
                default: 'Enkelzijdig',
                options: [
                  {
                    priceKey: 'printwijze',
                    name: 'Enkelzijdig',
                    title: 'Enkelzijdig',
                    disabledWhen: []
                  },
                  {
                    priceKey: 'printwijze',
                    name: 'Dubbelzijdig',
                    title: 'Dubbelzijdig',
                    disabledWhen: []
                  }
                ]
              },
              {
                name: 'papierType',
                productionCategory: 'Printopties',
                default: '_160_GRAMS',
                options: [
                  {
                    name: '_80_GRAMS',
                    title: '80 grams',
                    disabledWhen: [],
                    priceKey: 'papierType'
                  },
                  {
                    name: '_100_GRAMS',
                    title: '100 grams',
                    disabledWhen: [],
                    priceKey: 'papierType'
                  },
                  {
                    name: '_120_GRAMS',
                    title: '120 grams',
                    disabledWhen: [],
                    priceKey: 'papierType'
                  },
                  {
                    name: '_160_GRAMS',
                    title: '160 grams',
                    disabledWhen: [],
                    priceKey: 'papierType'
                  },
                  {
                    name: '_200_GRAMS',
                    title: '200 grams',
                    disabledWhen: [],
                    priceKey: 'papierType'
                  },
                  {
                    name: '_250_GRAMS',
                    title: '250 grams',
                    disabledWhen: [],
                    priceKey: 'papierType'
                  },
                  {
                    name: '_300_GRAMS',
                    title: '300 grams',
                    disabledWhen: [],
                    priceKey: 'papierType'
                  }
                ]
              }
            ]
          },
          {
            title: 'Afwerking',
            description: '',
            optionGroups: [
              {
                name: 'plastificeren',
                productionCategory: 'Afwerking',
                default: 'NONE',
                options: [
                  {
                    name: 'NONE',
                    title: 'Niet plastificeren',
                    disabledWhen: [],
                    priceKey: 'plastificeren'
                  },
                  {
                    name: 'PLASTIFICEREN_GLANS',
                    title: 'Plastificeren glans',
                    priceKey: 'plastificeren'
                  },
                  {
                    name: 'PLASTIFICEREN_MAT',
                    title: 'Plastificeren mat',
                    priceKey: 'plastificeren'
                  }
                ]
              },
              {
                name: 'schoonsnijden',
                productionCategory: 'Afwerking',
                default: 'SCHOONSNIJDEN',
                options: [
                  {
                    name: 'SCHOONSNIJDEN',
                    title: 'Schoonsnijden',
                    disabledWhen: [],
                    priceKey: 'orderafwerking'
                  },
                  {
                    name: 'NONE',
                    title: 'Niet schoonsnijden',
                    disabledWhen: [],
                    priceKey: 'orderafwerking'
                  }
                ]
              }
            ]
          },
          {
            title: 'Opmerking',
            description:
              'Plaats hier eventuele bijzonderheden met betrekking tot de geselecteerde bestanden.',
            optionGroups: [
              {
                name: 'opmerking',
                productionCategory: 'Opmerking'
              }
            ]
          }
        ]
      },
      //PRESENTATIE PANEEL
      {
        title: 'Presentatie paneel',
        image: 'default/presentatie-paneel.svg',
        menus: [
          {
            title: 'Printopties',
            description: '',
            optionGroups: [
              {
                name: 'formaat',
                productionCategory: 'Printopties',
                default: 'A4',
                options: [
                  {
                    name: 'A3',
                    title: 'A3',
                    priceKey: 'formaat'
                  },
                  {
                    name: 'A4',
                    title: 'A4',
                    priceKey: 'formaat'
                  },
                  {
                    name: 'A5',
                    title: 'A5',
                    priceKey: 'formaat'
                  },
                  {
                    name: 'A6',
                    title: 'A6',
                    priceKey: 'formaat'
                  },
                  {
                    name: 'ALS_BESTAND',
                    title: 'Als bestand',
                    priceKey: 'formaat'
                  }
                ]
              },
              {
                name: 'papierType',
                productionCategory: 'Printopties',
                default: 'HONINGRAATKARTON_10_MM',
                options: [
                  {
                    name: 'HONINGRAATKARTON_10_MM',
                    title: 'Honingraatkarton 10 mm FSC',
                    disabledWhen: [],
                    priceKey: 'papierType'
                  },
                  {
                    name: 'FOAMBOARD_5_MM',
                    title: 'Foamboard 5mm',
                    disabledWhen: [],
                    priceKey: 'papierType'
                  },
                  {
                    name: 'FOAMBOARD_10_MM',
                    title: 'Foamboard 10mm',
                    disabledWhen: [],
                    priceKey: 'papierType'
                  },
                  {
                    name: 'FOREX_3_MM',
                    title: 'Recycled kunststof wit 3mm (Forex)',
                    disabledWhen: [],
                    priceKey: 'papierType'
                  },
                  {
                    name: 'FOREX_5_MM',
                    title: 'Recycled kunststof wit 5mm (Forex)',
                    disabledWhen: [],
                    priceKey: 'papierType'
                  },
                  {
                    name: 'DIBOND_3_MM',
                    title: 'Aluminium sandwichplaat (Dibond)',
                    disabledWhen: [],
                    priceKey: 'papierType'
                  },
                  {
                    name: 'ACRYLAAT_HELDER_5_MM',
                    title: 'Recycled Acrylaat helder 5mm',
                    disabledWhen: [],
                    priceKey: 'papierType'
                  },
                  {
                    name: 'SCHEURVAST_1_2_MM',
                    title: 'Scheurvast kunststof 1,2mm',
                    disabledWhen: [],
                    priceKey: 'papierType'
                  }
                ]
              }
            ]
          },
          {
            title: 'Afwerking',
            description: '',
            optionGroups: [
              {
                name: 'schoonsnijden',
                productionCategory: 'Afwerking',
                default: 'SCHOONSNIJDEN',
                options: [
                  {
                    name: 'SCHOONSNIJDEN',
                    title: 'Schoonsnijden',
                    disabledWhen: [],
                    priceKey: 'orderafwerking'
                  },
                  {
                    name: 'NONE',
                    title: 'Niet schoonsnijden',
                    disabledWhen: [],
                    priceKey: 'orderafwerking'
                  }
                ]
              }
            ]
          },
          {
            title: 'Opmerking',
            description:
              'Plaats hier eventuele bijzonderheden met betrekking tot de geselecteerde bestanden.',
            optionGroups: [
              {
                name: 'opmerking',
                productionCategory: 'Opmerking'
              }
            ]
          }
        ]
      },
      //visitekaartjes
      {
        title: 'Visitekaartjes',
        image: 'default/visitekaartjes.svg',
        menus: [
          {
            title: 'Staffel',
            description: '',
            optionGroups: [
              {
                name: 'staffel',
                productionCategory: 'Staffel',
                default: '_100',
                options: [
                  {
                    name: '_100',
                    priceKey: 'staffel',
                    title: '100 kaartjes'
                  },
                  {
                    name: '_500',
                    priceKey: 'staffel',
                    title: '500 kaartjes'
                  }
                ]
              }
            ]
          },
          {
            title: 'Printopties',
            description: '',
            optionGroups: [
              {
                name: 'formaat',
                productionCategory: 'Printopties',
                default: 'A4',
                options: [
                  {
                    name: 'A4',
                    title: '85mm x 55mm',
                    priceKey: 'formaat'
                  }
                ]
              },
              {
                name: 'printkleur',
                productionCategory: 'Printopties',
                default: 'KLEUR',
                analyseValue: true,
                options: [
                  {
                    name: 'KLEUR',
                    title: 'Kleur',
                    priceKey: 'printkleur',
                    disabledWhen: []
                  },
                  {
                    name: 'ZWART_WIT',
                    title: 'Zwart / wit',
                    priceKey: 'printkleur',
                    disabledWhen: []
                  }
                ]
              },
              {
                name: 'printwijze',
                productionCategory: 'Printopties',
                default: 'Dubbelzijdig',
                options: [
                  {
                    priceKey: 'printwijze',
                    name: 'Enkelzijdig',
                    title: 'Enkelzijdig',
                    disabledWhen: []
                  },
                  {
                    priceKey: 'printwijze',
                    name: 'Dubbelzijdig',
                    title: 'Dubbelzijdig',
                    disabledWhen: []
                  }
                ]
              },
              {
                name: 'papierType',
                productionCategory: 'Printopties',
                default: '_300_GRAMS_WIT',
                options: [
                  {
                    name: '_300_GRAMS_WIT',
                    title: '300 grams wit',
                    disabledWhen: [],
                    priceKey: 'papierType'
                  },
                  {
                    name: '_300_GRAMS_OFF_WHITE',
                    title: '300 grams off-white',
                    disabledWhen: [],
                    priceKey: 'papierType'
                  }
                ]
              }
            ]
          },
          {
            title: 'Opmerking',
            description:
              'Plaats hier eventuele bijzonderheden met betrekking tot de geselecteerde bestanden.',
            optionGroups: [
              {
                name: 'opmerking',
                productionCategory: 'Opmerking'
              }
            ]
          }
        ]
      }
    ],
    userPrintTemplates: [],
    propositonProducts: []
  }),
  actions: {
    async hydrateProducts(fileName, isAdditional, propSpecs = false) {
      try {
        const products = await getProducts(fileName)
        if (propSpecs) {
          this.propositonProducts = products
        } else if (!isAdditional) {
          this.products = products
        } else {
          this.products = this.products.concat(products)
        }
      } catch (error) {
        console.error('Failed to load products:', error)
      }
    },
    async hydrateSecuredProducts(fileName, isAdditional = false) {
      try {
        const securedProducts = await getProducts(fileName)

        if (!isAdditional) {
          this.productsSecured = securedProducts
        } else {
          this.productsSecured = this.productsSecured.concat(securedProducts)
        }
      } catch (error) {
        console.error('Failed to load products:', error)
      }
    },
    async hydrateUserPrintTemplates() {
      try {
        let userPrintTemplates = await getUserPrintTemplates()

        if (!Array.isArray(userPrintTemplates)) {
          console.warn(
            'userPrintTemplates is not an array:',
            userPrintTemplates
          )
          this.userPrintTemplates = []
        } else if (userPrintTemplates.length === 0) {
          this.userPrintTemplates = []
        } else {
          this.userPrintTemplates = userPrintTemplates.sort((a, b) => {
            const nameA = a?.template?.name || ''
            const nameB = b?.template?.name || ''
            return nameA.loca
          })
        }
      } catch (error) {
        console.error('Failed to load print templates:', error)
      }
    },
    async deleteUserTemplate(id) {
      try {
        await deleteUserPrintTemplate(id)
        // Verwijder het template uit de lokale array
        this.userPrintTemplates = this.userPrintTemplates.filter(
          (template) => template.id !== id
        )
      } catch (error) {
        console.error('Failed to delete template:', error)
      }
    },
    async saveUserTemplate(template) {
      try {
        await saveUserPrintTemplate(template)
        this.hydrateUserPrintTemplates()
      } catch (error) {
        console.error('Failed to save print templates:', error)
      }
    }
  }
})
